export const OVERLAY_COLOR_CLASSES = {
    green: "bg-positive-surface",
    red: "bg-danger-surface",
    yellow: "bg-warning-surface",
    gray: "bg-muted"
};
export const OVERLAY_COLOR_HEX = {
    green: {
        fill: "#F0FDF4",
        stroke: "#22c55e"
    },
    red: {
        fill: "#FEF2F2",
        stroke: "#ef4444"
    },
    yellow: {
        fill: "#FEFCE8",
        stroke: "#eab308"
    },
    gray: {
        fill: "#F3F4F6",
        stroke: "#9ca3af"
    }
};
const OVERLAY_COLOR_RANK = {
    gray: 0,
    green: 1,
    yellow: 2,
    red: 3
};
/**
 * Node id → the overlay that wins for it. Several overlays can name the same
 * node; the most severe colour takes the slot.
 */ export function buildNodeOverlayMap(overlays) {
    const map = new Map();
    if (!overlays) return map;
    for (const overlay of overlays){
        const existing = map.get(overlay.nodeId);
        if (!existing || OVERLAY_COLOR_RANK[overlay.color] > OVERLAY_COLOR_RANK[existing.color]) {
            map.set(overlay.nodeId, overlay);
        }
    }
    return map;
}
export function getUserLabel(u) {
    return `${u.firstName ?? ""} ${u.lastName ?? ""}`.trim() || u.email || u._id;
}
export function getAssigneeName(step) {
    const { assignedTo } = step;
    if (!assignedTo || typeof assignedTo === "string") return "";
    const obj = assignedTo;
    if (obj.firstName && obj.lastName) return `${obj.firstName} ${obj.lastName}`;
    if (obj.name) return obj.name;
    return "";
}
// A step is "skeleton" when the author hasn't filled in its defining detail.
// Decisions are defined by their rules (not `task.taskDescription`), so their
// empty state is "no rules" — checking task-only fields would falsely dash
// every decision without a generated name.
export function isStepSkeleton(step) {
    if (step.actionType === "decision") {
        return !step.rules || step.rules.length === 0;
    }
    return !step.generatedName && !step.task?.taskDescription;
}

//# sourceMappingURL=utils.js.map